import styled from 'styled-components';

import { Clickable } from '@catalyze/ui';

export const RemoveButton = styled(Clickable)`
    font-size: ${({ theme }) => theme.fontSizes[2]};
    color: ${({ theme }) => theme.colors.fontPrimary};
    text-decoration: underline;
    position: absolute;
    top: 0;
    right: 0;
`;

export const AddButton = styled(RemoveButton)`
    font-weight: 700;
    position: relative;
    display: flex;
    width: 100%;
    justify-content: flex-end;
`;

export const FormLine = styled.div`
    position: relative;
`;
